/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';
import { AxiosInstance } from 'axios';

export interface ICustomerPortalFeatures {
    getFeatureGates(cancelToken?: CancelToken): AxiosPromise<CustomerPortalFeatureGates>;
}

export const BASE_URL_TOKEN_CustomerPortalFeatures = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class CustomerPortalFeatures implements ICustomerPortalFeatures {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private readonly axios: AxiosInstance, @inject(BASE_URL_TOKEN_CustomerPortalFeatures) @optional() private readonly baseUrl = "") {
    }

    getFeatureGates(cancelToken?: CancelToken): AxiosPromise<CustomerPortalFeatureGates> {
        let url_ = "/v1/customerportal2/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<CustomerPortalFeatureGates>(options_));
    }
}

export interface CustomerPortalFeatureGates {
    tenantName?: string | undefined;
    enabledFeatureGates?: string[] | undefined;
}
